<div class="container">
  <div class="header">
    <div *ngIf="!['EDIT', 'NEW'].includes(openType)">
      <div class="subTitle">Créer un profil</div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between stretch">
      <div class="title">Compétences</div>
      <app-smart-op-avatar [profile]="profile" fxFlexAlign="center"></app-smart-op-avatar>
    </div>
  </div>

  <div *ngIf="isLoading" class="spinnerContainer" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>

  <form class="body" fxLayout="column" fxLayoutAlign="space-between stretch">
    <div *ngIf="!isLoading && (!specialtiesWithRanks || specialtiesWithRanks.length <= 0)">
      Aucune compétence n'est disponible pour cette formation
    </div>

    <div
      *ngIf="specialtiesWithRanks && specialtiesWithRanks.length > 0"
      fxFlex="row"
      fxLayoutAlign="start center"
      class="padding-right"
      style="margin-left: 270px; margin-bottom: 12px"
    >
      <div *ngFor="let specialty of listOfRatings" class="levels-header">Niveau</div>
    </div>

    <div
      *ngIf="specialtiesWithRanks && specialtiesWithRanks.length > 0"
      fxFlex="row"
      fxLayoutAlign="start center"
      class="padding-right"
    >
      <div style="margin-right: 196px" class="main-header">{{ hospitalNames.specialtiesName }}s</div>

      <div class="main-header role-header" *ngFor="let rating of listOfRatings">{{ rating.role.name }}</div>
    </div>

    <overlay-scrollbars
      *ngIf="specialtiesWithRanks && specialtiesWithRanks.length > 0"
      class="specialties-container"
      [options]="$any(osComponentOptions)"
    >
      <div
        *ngFor="let specialtyWithRank of specialtiesWithRanks; index as i"
        fxLayout="row"
        fxLayoutAlign="start"
        class="specialty-row"
      >
        <div
          fxFlexLayout="row"
          fxFlexAlign="start center"
          style="max-width: 256px; min-width: 256px; margin-right: 12px"
        >
          <div
            *ngIf="imgLinks && imgLinks.length != 0"
            fxFlex="50px"
            fxFlexAlign="center center"
            class="specialtyIconContainer"
          >
            <img class="specialtyIcon" [src]="imgLinks[i]" />
          </div>

          <div class="specialtyNameContainer">
            <span class="specialtyName">
              {{ specialtyWithRank.specialtyName }}
            </span>
          </div>
        </div>

        <div class="default-select selectors" *ngFor="let rating of listOfRatings">
          <div class="select-container" *ngIf="isSpecialtyHaveRole(specialtyWithRank, rating)">
            <select
              required
              [disabled]="specialtyWithRank.skillsInitializedFromOtherHospitals"
              [(ngModel)]="getSpecialtyRole(specialtyWithRank, rating).nurseLevel"
              [ngModelOptions]="{ standalone: true }"
              (change)="skillChanged(specialtyWithRank, rating)"
            >
              <option
                *ngFor="let sp of generateListByLength(getSpecialtyRole(specialtyWithRank, rating).maxLevel)"
                [value]="sp - 1"
              >
                {{ sp - 1 }}/{{ getSpecialtyRole(specialtyWithRank, rating).maxLevel - 1 }}
              </option>
            </select>
          </div>

          <div
            class="select-container select-container-no-role"
            *ngIf="!isSpecialtyHaveRole(specialtyWithRank, rating)"
          >
            <select required [value]="0" [disabled]="true">
              <option [value]="0">0</option>
            </select>
          </div>
        </div>
      </div>
    </overlay-scrollbars>
  </form>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center" *ngIf="specialtiesWithRanks">
    <app-button *ngIf="!isWithoutCloseBtn" text="Annuler" btnType="text" (click)="closeDialog()"></app-button>
    <app-button
      [text]="
        openType === 'EDIT' ? 'Modifier les compétences' : openType === 'NEW' ? 'Ajouter le service' : 'Créer le profil'
      "
      (click)="onSkillsValidation()"
    ></app-button>
  </div>
</div>
